import { useMemo } from 'react';
import {
  LrwSessionDetailsDto,
  LrwSessionUpdateCapabilitiesDto,
  OnComputerWritingFormat,
} from 'api/planning';

export const useWritingFormatToggleCapabilities = ({
  lrwSession,
  updateCapabilities,
}: {
  lrwSession?: LrwSessionDetailsDto;
  updateCapabilities?: LrwSessionUpdateCapabilitiesDto;
}) => {
  const canToggleOnComputer = useMemo(() => {
    if (!lrwSession || !updateCapabilities) {
      return false;
    }

    const isOnComputerEnabled = lrwSession.onComputerWritingFormats.includes(
      OnComputerWritingFormat.OnComputer
    );

    return isOnComputerEnabled
      ? updateCapabilities.canDisableOnComputerWritingFormat
      : updateCapabilities.canEnableOnComputerWritingFormat;
  }, [lrwSession, updateCapabilities]);

  const canToggleOnPaper = useMemo(() => {
    if (!lrwSession || !updateCapabilities) {
      return false;
    }

    const isOnPaperEnabled = lrwSession.onComputerWritingFormats.includes(
      OnComputerWritingFormat.OnPaper
    );

    return isOnPaperEnabled
      ? updateCapabilities.canDisableOnPaperWritingFormat
      : updateCapabilities.canEnableOnPaperWritingFormat;
  }, [lrwSession, updateCapabilities]);

  return { canToggleOnComputer, canToggleOnPaper };
};
